import { Link } from 'react-router-dom';
import forgotPassword from '../../assets/images/icons/forgotPassword.svg';
import Button from '../../components/Button';
import { ButtonContainer } from '../../components/Form';
import Loader from '../../components/Loader';
import { Container } from './styles';

import Transitions from '../../components/Transition';
import ChangePasswordView from './components/ChangePasswordView';
import SendCodeView from './components/SendCodeView';
import Title from './components/Title';
import useForgotPassword from './useForgoutPassword';

export default function ForgotPassword() {
  const {
    isLoading,
    getErrorMessageByFieldName,
    cpf,
    handleCpfChange,
    resetPassword,
    isReadyToSendCode,
    visualizationKind,
    sendValidateCodeToEmail,
    handlePasswordChange,
    handlePasswordConfirmationChange,
    setValidationCode,
    isReadyToResetPassword,
    validationCode,
    password,
    passwordConfirmation,
  } = useForgotPassword();

  return (
    <Transitions>
      <Loader isLoading={isLoading} />
      <Container>
        <div className="asideGif">
          <img src={forgotPassword} alt="busGif" />
        </div>

        <div className="asideLogin">
          <Title visualizationKind={visualizationKind} />

          <div className="loginForm">
            <div className="loginInput">
              {visualizationKind === 'sendCode' && (
                <SendCodeView
                  getErrorMessageByFieldName={getErrorMessageByFieldName}
                  cpf={cpf}
                  handleCpfChange={handleCpfChange}
                />
              )}

              {visualizationKind === 'changePassword' && (
                <ChangePasswordView
                  validationCode={validationCode}
                  setValidationCode={setValidationCode}
                  getErrorMessageByFieldName={getErrorMessageByFieldName}
                  password={password}
                  handlePasswordChange={handlePasswordChange}
                  passwordConfirmation={passwordConfirmation}
                  handlePasswordConfirmationChange={handlePasswordConfirmationChange}
                />
              )}
            </div>
          </div>

          <ButtonContainer flexDirection='column'>
            <Button
              type="button"
              onClick={visualizationKind === 'sendCode'
                ? () => sendValidateCodeToEmail()
                : () => resetPassword()}
              disabled={visualizationKind === 'sendCode'
                ? !isReadyToSendCode
                : !isReadyToResetPassword}
            >
              {visualizationKind === 'sendCode' ? 'Enviar código para alteração de senha' : 'Trocar minha senha'}
            </Button>
            <div className="backToLogin">
              <Link to="/">Realizar login</Link>
            </div>
          </ButtonContainer>
        </div>
      </Container>
    </Transitions>
  );
}
